import type { Creature } from '@/domain/creature/types';
import type { CombatStats, CombatRuntime } from './types';

export const BASE_DAMAGE = 10;
export const BASE_MAX_HP = 100;
export const BASE_SPEED = 120;
export const BASE_ATTACK_SPEED = 1.0;
export const BASE_CRIT_CHANCE = 0.05;

/**
 * Stats base derivadas da criatura (sem mutações).
 * weight afeta maxHp; body gene futura modifica speed.
 */
export function baseStatsFor(c: Creature): CombatStats {
  const weightBonus = (c.state.weight - 50) * 0.4;
  return {
    maxHp: Math.max(20, BASE_MAX_HP + weightBonus),
    damage: BASE_DAMAGE,
    speed: BASE_SPEED,
    attackSpeed: BASE_ATTACK_SPEED,
    critChance: BASE_CRIT_CHANCE,
  };
}

export function makeRuntime(stats: CombatStats, _now: number): CombatRuntime {
  return {
    hp: stats.maxHp,
    maxHp: stats.maxHp,
    lastAttackAt: 0,
    lastSkillAt: 0,
    burnUntil: null,
    shieldUntil: null,
    bloodlustUntil: null,
    phoenixUsed: false,
  };
}
